<template>
  <div class="vote-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Index'
}
</script>

<style lang="stylus" scoped>
.vote-container
  width: 100%
  height: 100%
</style>
